import $ from 'cash-dom';
import Cookie from 'js-cookie';

const ExitPopupMobileTriggers = {
	_activeCleanup: null,

	cleanupCurrentListeners() {
		if (typeof this._activeCleanup === 'function') {
			this._activeCleanup();
			this._activeCleanup = null;
		}
	},

	_getDelegate(delegate) {
		return {
			isShown: typeof delegate?.isShown === 'function' ? delegate.isShown : () => false,
			showPopup: typeof delegate?.showPopup === 'function' ? delegate.showPopup : () => { },
		};
	},

	showVpnmentorMobilePopup(delegate, forceExitIntent) {
		this.cleanupCurrentListeners();

		const { isShown, showPopup } = this._getDelegate(delegate);

		if (forceExitIntent || (Cookie.get('_exit_ppc_pp') === undefined && $(window).height() > 525)) {
			let lastInteractionTime = Date.now();
			let inactivityCheckInterval = null;
			let contentEndReached = false;
			let maxScrollTop = 0;

			const $chart = $('.vendors-list, .vendors-container').first();
			const isPpcChart = $chart.length > 0;

			let $mainContent = $('#single_post_page article.content').first();
			if (!$mainContent.length) {
				$mainContent = $('article.content').first();
			}
			if (!$mainContent.length) {
				$mainContent = $('#single_post_page').first();
			}
			const isBlogLike = !isPpcChart && $mainContent.length > 0;

			let $footer = $('footer#main-footer, footer#wc-site-footer').first();
			if (!$footer.length) {
				$footer = $('footer').first();
			}

			let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
			let lastScrollTime = Date.now();
			let accumulatedScrollUp = 0;
			let maxUpVelocity = 0;

			const cleanupListeners = () => {
				$(window).off('scroll', triggerScroll);
				window.removeEventListener('touchmove', handleTouchMove);
				window.removeEventListener('touchstart', handleTouchStart);
				window.removeEventListener('click', registerInteraction);
				if (inactivityCheckInterval) {
					clearInterval(inactivityCheckInterval);
				}
				if (this._activeCleanup === cleanupListeners) {
					this._activeCleanup = null;
				}
			};

			this._activeCleanup = cleanupListeners;

			const registerInteraction = () => {
				lastInteractionTime = Date.now();
			};

			const startInactivityCheck = () => {
				if (inactivityCheckInterval) {
					clearInterval(inactivityCheckInterval);
				}
				inactivityCheckInterval = setInterval(() => {
					if (isShown()) {
						cleanupListeners();
						return;
					}
					if (Date.now() - lastInteractionTime >= 10000) {
						showPopup('non_interaction_10_seconds');
						cleanupListeners();
					}
				}, 1000);
			};

			const checkPositions = (scrollTop) => {
				if (scrollTop > maxScrollTop) {
					maxScrollTop = scrollTop;
				}

				if (!contentEndReached) {
					const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
					let hasReachedEnd = false;

					if (isPpcChart && $chart.length) {
						const rect = $chart[0].getBoundingClientRect();
						hasReachedEnd = rect.bottom <= viewportHeight + 100;
					} else if (isBlogLike && $mainContent.length) {
						const rect = $mainContent[0].getBoundingClientRect();
						hasReachedEnd = rect.bottom <= viewportHeight + 100;
					} else if ($footer.length) {
						const rect = $footer[0].getBoundingClientRect();
						hasReachedEnd = rect.top <= viewportHeight + 100;
					} else {
						const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
						hasReachedEnd = scrollTop >= (docHeight * 0.85) - viewportHeight;
					}

					if (hasReachedEnd) {
						contentEndReached = true;
					}
				}
			};

			const evaluateTriggersOnScrollUp = (isFastUp, upDistance = 0) => {
				if (isShown()) {
					cleanupListeners();
					return;
				}

				const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
				const minScrollThreshold = Math.min(docHeight * 0.10, 200);
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				const currentMaxScroll = Math.max(maxScrollTop, scrollTop);

				// Must have scrolled down at least 10% (or 200px threshold)
				if (currentMaxScroll < minScrollThreshold) {
					return;
				}

				// PRIORITY 1: Fast scroll up anywhere on the site -> scroll_fast_up
				// Requires at least 80px of upward scroll distance + velocity > 1.5 px/ms to prevent false triggers during normal reading
				if (isFastUp && upDistance >= 80) {
					showPopup('scroll_fast_up');
					cleanupListeners();
					return;
				}

				// PRIORITY 2: Past chart/content or footer + normal (slow) scroll up -> end_content_scroll_up
				// Requires at least 30px of upward scroll distance to ensure intentional user movement
				if (contentEndReached && !isFastUp && upDistance >= 30) {
					showPopup('end_content_scroll_up');
					cleanupListeners();
				}
			};

			const handleTouchStart = () => {
				accumulatedScrollUp = 0;
				maxUpVelocity = 0;
				registerInteraction();
			};

			const handleTouchMove = () => {
				registerInteraction();
			};

			let initialCall = true;
			const triggerScroll = () => {
				if (isShown()) {
					cleanupListeners();
					return;
				}

				if (!initialCall) {
					registerInteraction();
				}
				initialCall = false;

				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				const scrollTime = Date.now();
				const deltaScrollY = lastScrollTop - scrollTop; // positive = scrolled UP
				const deltaTime = scrollTime - lastScrollTime;

				checkPositions(scrollTop);

				// Reset gesture metrics if user paused scrolling for > 200ms
				if (deltaTime > 200) {
					accumulatedScrollUp = 0;
					maxUpVelocity = 0;
				}

				// Detect scroll UP
				if (deltaScrollY > 2) {
					accumulatedScrollUp += deltaScrollY;
					const currentVelocity = deltaTime > 0 ? deltaScrollY / deltaTime : 0;
					if (currentVelocity > maxUpVelocity) {
						maxUpVelocity = currentVelocity;
					} else {
						maxUpVelocity = Math.max(currentVelocity, maxUpVelocity * 0.8);
					}

					evaluateTriggersOnScrollUp(maxUpVelocity > 1.5, accumulatedScrollUp);
				} else if (deltaScrollY < -5) {
					accumulatedScrollUp = 0;
					maxUpVelocity = 0;
				}

				lastScrollTop = scrollTop;
				lastScrollTime = scrollTime;
			};

			$(window).on('scroll', triggerScroll);
			window.addEventListener('touchmove', handleTouchMove, { passive: true });
			window.addEventListener('touchstart', handleTouchStart, { passive: true });
			window.addEventListener('click', registerInteraction, { passive: true });

			triggerScroll();
			startInactivityCheck();
		}
	},

	showRegularMobilePopup(delegate, forceExitIntent) {
		this.cleanupCurrentListeners();

		const { isShown, showPopup } = this._getDelegate(delegate);

		if (forceExitIntent || (Cookie.get('_exit_ppc_pp') === undefined && $(window).height() > 525)) {
			let scrollHappened = false;
			let timerId = null;
			const $secondVendor = $('.ppc-single-vendor.ppc-vendor-2').first();
			const $target = $secondVendor.length ? $secondVendor : $('.ppc-single-vendor').eq(1);

			const cleanupListeners = () => {
				$(window).off('scroll', triggerScroll);
				window.removeEventListener('touchmove', triggerTouchMove);
				if (timerId) {
					clearTimeout(timerId);
					timerId = null;
				}
				if (this._activeCleanup === cleanupListeners) {
					this._activeCleanup = null;
				}
			};

			this._activeCleanup = cleanupListeners;

			let initialCall = true;
			const triggerScroll = () => {
				const wasInitialCall = initialCall;
				initialCall = false;
				if (!wasInitialCall) {
					scrollHappened = true;
				}

				if (isShown()) {
					cleanupListeners();
					return;
				}
				if (!$target.length) {
					if (!wasInitialCall) {
						showPopup('no target trigger');
						cleanupListeners();
					}
					return;
				}

				const rect = $target[0].getBoundingClientRect();
				const $headerInner = $('.header-inner');
				const headerHeight = $headerInner.length ? $headerInner.outerHeight() : 0;
				const hasPassedSecondVendor = rect.bottom <= headerHeight;

				if (hasPassedSecondVendor) {
					showPopup('vendor trigger');
					cleanupListeners();
				}
			};

			const triggerTouchMove = () => {
				scrollHappened = true;
				window.removeEventListener('touchmove', triggerTouchMove);
			};

			$(window).on('scroll', triggerScroll);
			window.addEventListener('touchmove', triggerTouchMove, { passive: true });

			triggerScroll();

			timerId = setTimeout(() => {
				window.removeEventListener('touchmove', triggerTouchMove);
				if (isShown() || scrollHappened) {
					return false;
				}
				showPopup('time trigger 7 seconds');
				cleanupListeners();
			}, 7000);
		}
	}
};

export default ExitPopupMobileTriggers;
